import axiosInsAcademy from '@/api/axios-ugems-academy'

export const GET_CERTIFICATES = (params) => {
  return axiosInsAcademy.get('/certificates', { params });
};

export const GET_CERTIFICATE_BY_ID = (id, params) => {
  return axiosInsAcademy.get(`/certificates/${id}`, { params });
};

export const CREATE_CERTIFICATE = (data) => {
  return axiosInsAcademy.post('/certificates', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const UPDATE_CERTIFICATE = (id, data) => {
  return axiosInsAcademy.put(`/certificates/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const DELETE_CERTIFICATE = (id) => {
  return axiosInsAcademy.delete(`/certificates/${id}`);
};